import { Property } from 'csstype';
import styled from 'styled-components';

type ResponsiveCSSGridProps = (
	| {
			/**
			 * The minimum width of the child component within the Responsive Grid
			 */
			itemWidth: string;
	  }
	| {
			/** @obsolete use itemWidth instead. Width is passed to the element. */
			width: string;
	  }
) & {
	gap: string;
	align?: Property.JustifyItems;
	alignVertical?: Property.AlignItems;
	fullWidth?: boolean;
	margin?: string;
};

export const CSSGridDiv = styled.div`
	display: grid;
	max-width: 100%;
`;

// backwards compatible check
function isNewerAPI(thing: any): thing is { itemWidth: string } {
	return (thing as { itemWidth: string }).itemWidth !== undefined;
}

// use itemWidth
export const ResponsiveCSSGrid = styled(CSSGridDiv)<ResponsiveCSSGridProps>`
	grid-template-columns: repeat(auto-fill, minmax(${props => (isNewerAPI(props) ? props.itemWidth : props.width)}, 1fr));

	grid-gap: ${props => props.gap};
	justify-items: ${props => props.align};
	align-content: ${props => props.alignVertical ?? 'stretch'};
	width: ${props => (props.fullWidth ? '100%' : 'auto')};
	margin: ${props => props.margin ?? '0'};
`;
